module.exports = __webpack_public_path__ + "assets/img/living_2.c6e4a8dd.jpg";